import React, { createContext, useMemo } from 'react';
import { useTransactionEffects } from './useTransactionEffects';
import { Form } from 'antd';

export const TransactionContext = createContext({});

export default function TransactionProvider(props) {
    const { children } = props;

    const [form] = Form.useForm();
    const transactionEffects = useTransactionEffects(props, form);

    const value = useMemo(() => ({
        form,
        ...transactionEffects,
    }), [
        form,
        transactionEffects,
    ]);

    return (
        <TransactionContext.Provider value={value}>
            { children }
        </TransactionContext.Provider>
    );
}
